import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export const SPECIAL_PURPOSES = [
  {id: 1, name: 'Religious buildings'},
  {id: 2, name: 'Educational facilities'},
  {id: 3, name: 'Courthouse'},
  {id: 4, name: 'City Hall & Municipal Building'},
  {id: 5, name: 'Health care facilities'},
  {id: 6, name: 'Theaters and entertainment'},
  {id: 7, name: 'Gas stations'},
  {id: 8, name: 'Cold storage facilities'},
  {id: 9, name: 'Amusement Parks and Theme Parks'},
  {id: 10, name: 'Cemeteries'},
  {id: 11, name: 'Funeral homes'},
  {id: 12, name: 'Wineries'},
  {id: 13, name: 'Bowling alley'},
  {id: 14, name: 'Golf course'},
  {id: 15, name: 'Prison'},
  {id: 16, name: 'Data centers'}
]

@Injectable({
  providedIn: 'root'
})
export class SpecialPurposePropertyTypeService {
  private _types$ = new BehaviorSubject<{
    id: number,
    name: string
  }[]>(SPECIAL_PURPOSES)

  types$ = this._types$.asObservable()
}